import type { IconNode } from '../types';

/**
 * @name bottle-spray
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnY0IiAvPgogIDxwYXRoIGQ9Ik02IDEwaDQiIC8+CiAgPHBhdGggZD0iTTEwIDhhMiAyIDAgMCAxIDItMmgzYy42IDAgMS0uNCAxLTFWM2MwLS42LS40LTEtMS0xSDVDMy4zIDIgMiAzLjMgMiA1YzAgLjYuNCAxIDEgMWgxYTIgMiAwIDAgMSAyIDJ2MmwtMi4zIDIuM2MtLjQuNC0uNyAxLjEtLjcgMS43djZhMiAyIDAgMCAwIDIgMmg2YTIgMiAwIDAgMCAyLTJ2LTZjMC0uNi0uMy0xLjMtLjctMS43TDEwIDEwWiIgLz4KICA8cGF0aCBkPSJNMTQgNmMwIDIgMCAzIDIgNCIgLz4KICA8cGF0aCBkPSJNMyAxNi41YTYgNiAwIDAgMSA1IDBzMiAxLjI1IDUgMCIgLz4KICA8cGF0aCBkPSJNMjIgMmguMDEiIC8+CiAgPHBhdGggZD0iTTIwIDUuNWguMDEiIC8+CiAgPHBhdGggZD0iTTIyIDloLjAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bottle-spray
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bottleSpray: IconNode = [
  ['path', { d: 'M12 2v4', key: '3427ic' }],
  ['path', { d: 'M6 10h4', key: 'c4prmk' }],
  [
    'path',
    {
      d: 'M10 8a2 2 0 0 1 2-2h3c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1H5C3.3 2 2 3.3 2 5c0 .6.4 1 1 1h1a2 2 0 0 1 2 2v2l-2.3 2.3c-.4.4-.7 1.1-.7 1.7v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6c0-.6-.3-1.3-.7-1.7L10 10Z',
      key: '132wqn',
    },
  ],
  ['path', { d: 'M14 6c0 2 0 3 2 4', key: '1cmuzk' }],
  ['path', { d: 'M3 16.5a6 6 0 0 1 5 0s2 1.25 5 0', key: '1fsdx0' }],
  ['path', { d: 'M22 2h.01', key: '19v55c' }],
  ['path', { d: 'M20 5.5h.01', key: '1k48dz' }],
  ['path', { d: 'M22 9h.01', key: 'npkp49' }],
];

export default bottleSpray;
